import { Form } from '@unistocks/components/form/form';
import { oneOf, requiredSchema } from '@unistocks/components/form/validators';
import { PeriodSelect } from '@unistocks/features/dashboard/components/settings/period-select';
import { PortfolioFilter } from '@unistocks/features/dashboard/components/settings/portfolio-filter';
import { t } from '@unistocks/localization';
import { DateConstant } from '@unistocks/proxy/axios-client';
import { dateConstantOptions } from '@unistocks/shared/utils/enums/date-constant';
import { z } from 'zod';

export const netSavingsSchemaFactory = () =>
  z.object({
    title: z.string().nullish(),
    portfolios: z
      .array(z.string())
      .nullish()
      .refine(
        value => value?.length === 1,
        t('::ValidationError:Required:Selection', { 0: t('::Portfolio') })
      ),
    period: requiredSchema(
      oneOf(
        dateConstantOptions
          .map(({ value }) => value)
          .filter(value => ![DateConstant.OneDay, DateConstant.OneWeek].includes(value))
      ),
      t('::Dashboard:Settings:DateRange')
    )
  });

export const NetSavingsSettings: React.FC = () => {
  return (
    <>
      <Form.Input
        name={'title'}
        label={t('::DisplayName')}
        helpText={t('::Dashboard:Settings:Title:HelpText')}
      />
      <PortfolioFilter
        portfolioSelectOverrides={{ multiple: false }}
        sectionSelectOverrides={{ hidden: true }}
        assetTypeSelectOverrides={{ hidden: true }}
      />
      <PeriodSelect
        isValidOption={date => date >= DateConstant.OneMonth && date < DateConstant.Max}
      />
    </>
  );
};

NetSavingsSettings.displayName = 'NetSavingsSettings';
